import { publicOrigin } from '@maxpreps/network/src/origins';

export const pseudoSchoolRedirectUrl = `${publicOrigin}/utility/about_pseudo_schools.aspx`;

interface IPseudoSchool {
  id: string;
  name: string;
  levels: string[];
  tournament?: boolean;
}

// if this is manipulated it will screw shit up.
// If that ever becomes a problem we should only return copies of this
const PSEUDO_SCHOOLS: IPseudoSchool[] = [
  {
    id: '23BAE8A4-95F3-4F43-99BB-9C0A28566B66',
    name: 'Varsity Opponent',
    levels: ['Varsity']
  },
  {
    id: '73C7D62C-910C-4AB7-BDC6-ECBEB8CB3398',
    name: 'JV Opponent',
    levels: ['JV']
  },
  {
    id: 'B51244AB-A965-47E5-ADDB-4F44F26C49ED',
    name: 'Freshman Opponent',
    levels: ['Freshman']
  },
  {
    id: '4FC9DCD1-3D2C-4D0A-998E-4340BAC0AC02',
    name: 'Non-Varsity Opponent',
    levels: ['Varsity']
  },
  {
    id: 'D1BD084E-1F5B-4E7C-8F99-6C63E0E9E855',
    name: 'Non-JV Opponent',
    levels: ['JV']
  },
  {
    id: '505C1A99-E49F-4DAA-8EC8-355BAF311697',
    name: 'Non-Freshman Opponent',
    levels: ['Freshman']
  },
  {
    id: '001393EA-2648-404B-8205-6E19AC70A214',
    name: 'Non-Varsity Tournament Opponent',
    levels: ['Varsity'],
    tournament: true
  },
  {
    id: 'B6E1F3F8-F345-4829-80A4-0653A9A36A1D',
    name: 'Tournament Opponent',
    levels: ['Varsity', 'JV', 'Freshman'],
    tournament: true
  },
  {
    id: '82f0f6a8-1232-4b30-a5a7-8cc4f32359e4',
    name: 'Tournament Team',
    levels: ['Varsity', 'JV', 'Freshman'],
    tournament: true
  }
];

export default PSEUDO_SCHOOLS;
